import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../data/mockData';
import { useScrollReveal } from '../hooks/useScrollReveal';

const Testimonials = () => {
  const [sectionRef, isSectionVisible] = useScrollReveal();
  const doubledTestimonials = [...testimonials, ...testimonials];

  return (
    <section className="py-20 lg:py-28 bg-gray-50 overflow-hidden">
      <div
        ref={sectionRef}
        className={`reveal ${isSectionVisible ? 'visible' : ''}`}
      >
        {/* Header */}
        <div className="section-container mb-14">
          <span
            className="block text-sm font-semibold text-[#00BCE4] uppercase tracking-[3px] mb-3"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Endorsements
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            What our clients say<br />
            <span className="text-[#00BCE4]">about Imprint...</span>
          </h2>
        </div>

        {/* Scrolling Testimonials */}
        <div className="relative">
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-gray-50 to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-gray-50 to-transparent z-10"></div>

          <div className="overflow-hidden">
            <div className="testimonial-scroll-track">
              {doubledTestimonials.map((testimonial, index) => (
                <div
                  key={`${testimonial.author}-${index}`}
                  className="flex-shrink-0 mx-4 w-[420px]"
                >
                  <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 h-full hover:shadow-xl hover:border-[#00BCE4]/20 transition-all duration-500">
                    <Quote size={32} className="text-[#00BCE4] mb-4 opacity-40" />
                    <blockquote
                      className="text-sm text-gray-600 leading-relaxed mb-6"
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    >
                      "{testimonial.quote}"
                    </blockquote>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-[#00BCE4]/10 flex items-center justify-center">
                        <span
                          className="text-sm font-bold text-[#00BCE4]"
                          style={{ fontFamily: 'Outfit, sans-serif' }}
                        >
                          {testimonial.company.charAt(0)}
                        </span>
                      </div>
                      <span
                        className="text-sm font-semibold text-gray-900"
                        style={{ fontFamily: 'Outfit, sans-serif' }}
                      >
                        {testimonial.company}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
